import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { setQueryPosition } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

export const useRefreshRecordedDocuments = (leadId: string) => {
    const queryClient = useQueryClient();

    return useCallback(
        async (position?: number | null) => {
            const queryKey = queryKeys.getRecordedDocuments(leadId);
            if (typeof position === 'number') setQueryPosition(JSON.stringify(queryKey), position);
            // Base key without position prefix-matches the query for every position.
            await Promise.all([
                queryClient.invalidateQueries({ queryKey }),
                queryClient.invalidateQueries({ queryKey: queryKeys.getAcknowledgedDocuments(leadId) }),
            ]);
        },
        [leadId, queryClient],
    );
};
